module.exports = __webpack_public_path__ + "static/img/ebook_index_four.feaf8bc1.jpg";